function useTranslationsOverrides() {
    const result = {
        dateUnavailableMessage: '{0} is unavailable.',
        startDateInvalidMessage: '{0} is not a valid check-in date',
        startDateSelectedMessage: '{0} is selected as your check-in date',
        endDateInvalidMessage: '{0} is not a valid check-out date.',
        endDateSelectedMessage: '{0} is selected as your check-out date.',
        directionsMessage: 'Check-in date expanded. Choose a date from the table below. Tab into the table and use the arrow keys for navigation.',
        prevMonthButtonLabel: 'Previous month',
        nextMonthButtonLabel: 'Next month',
        datesClearedMessage: 'Dates cleared.',
        startDateClearedMessage: 'Check-in date cleared.',
        endDateClearedMessage: 'Check-out date cleared.',
        clearSearchLabel: 'Clear Search',
        premiseLabel: 'Premise',
        premisesLabel: 'Premises',
        recentSearchesMessage: 'Your recent searches',
        recentlyViewedLabel: 'Recently Viewed',
        trendingDestinationsMessage: 'Trending destinations today',
        typeAirportLabel: 'Airport',
        typeCityLabel: 'City',
        typeLandmarkLabel: 'Landmark',
        typeMetroStationLabel: 'Metro Station',
        typeNeighborhoodLabel: 'Neighborhood',
        typePropertyLabel: 'Property',
        typeRegionLabel: 'Region',
        typeTrainStationLabel: 'Train Station',
        resultsFoundMessage: '{NUM_RESULTS} results. Use the up and down keys to navigate.',
        selectedMessage: 'Destination selected={DESTINATION}',
    };

    return result;
}

export {useTranslationsOverrides};